var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card"},[(_vm.close)?_c('span',{staticClass:"close",on:{"click":function($event){return _vm.close()}}},[_c('icon-base',{attrs:{"viewBox":"0 0 24 24","width":"15","height":"15"}},[_c('IconClose2')],1)],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }